<app-view-item *ngIf="readonly" [text]="selected?.code" [tabindex]="tabindex"></app-view-item>
<div class="agent-select-container" *ngIf="!readonly">
  <nz-select #selector nzShowSearch nzServerSearch [nzAllowClear]="true" [nzBackdrop]="addBackdrop" (keydown)="handleKeyDown($event)"
    [nzFilterOption]="nzFilterOption" (nzOnSearch)="search($event, 100)" (nzOpenChange)="onDropdownOpenChange($event)"
    (nzScrollToBottom)="loadMore()" [nzCustomTemplate]="displayTpl" (click)="handleClick($event)" [(ngModel)]="value"
    (ngModelChange)="valueChanged($event)" [nzDropdownMatchSelectWidth]="false" [nzBorderless]="borderless"
    [nzDropdownRender]="null" nzDropdownClassName="dropdownSelect" class="width-100" [nzMode]="mode"
    [tabindex]="tabindex">
    <ng-template #displayTpl let-selected>
      {{ selected.nzLabel }}
    </ng-template>
    <!-- Add New Button -->
    <ng-container *aclIf="{ ability: ['m1.2', 'agent.create'], mode: 'allOf' }">
      <nz-option *ngIf="!this.NotShowInReport" [nzValue]="null" [nzLabel]="'__addnew__'" nzCustomContent>
        <div class="text-center">
          <button type="button" nz-button nzType="primary" class="add-new-button" (click)="$event.stopPropagation(); onAddNewClick($event)">
            <span nz-icon nzType="plus"></span>
            {{ storedInstantData ? ' Add New \''+ storedInstantData +'\'' : ' Add New' }}
          </button>
        </div>
      </nz-option>
    </ng-container>
    <ng-container *ngFor="let o of list">
      <nz-option *ngIf="!searching" [nzValue]="getValue(o)" [nzLabel]="o.code" nzCustomContent>
        <span>{{ o.code }}</span>
        :
        <span> {{ o.name }}</span>
      </nz-option>
    </ng-container>


  </nz-select>

  <!-- Inline Add Panel -->
  <app-inline-add-panel #inlineAddPanel [config]="agentConfig" [visible]="showInlineAddPanel"
    [initialData]="inlineDefaults" (itemCreated)="onAgentCreated($event)" (cancelled)="onAgentCancelled()"
    (visibleChange)="onPanelVisibleChange($event)" (moreDetails)="onAgentMoreDetails()"
    (fieldChange)="onFieldChange($event)"></app-inline-add-panel>
</div>